import { render, staticRenderFns } from "./ShippingItems.html?vue&type=template&id=210b5f13&external"
import script from "./ShippingItems.ts?vue&type=script&lang=ts&external"
export * from "./ShippingItems.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingItems.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports